// src/components/function/formatDateTimeByLang.js
export const formatDateTimeByLang = (dateStr, lang = "tr") => {
  if (!dateStr) return "";

  const date = new Date(dateStr);
  if (isNaN(date)) return dateStr;

  let locale;
  switch (lang) {
    case "en":
      locale = "en-GB"; // EN formatı
      break;
    case "fr":
      locale = "fr-FR"; // FR formatı
      break;
    case "de":
      locale = "de-DE"; // DE formatı
      break;
    case "tr":
    default:
      locale = "tr-TR"; // TR formatı
      break;
  }
  
  return new Intl.DateTimeFormat(locale, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false, // 24 saat formatı
  }).format(date);
};
